// Configuração específica para a API de Statistics na porta 9004
import axios from 'axios';
import customToast from 'components/toast/customToatsStandalone';

import { environmentVars } from './variables/environment';
import getErrorAction from './variables/getErrorAction';

// URL base específica para statistics usando environment variables
const getStatisticsBaseURL = () => {
	return environmentVars.aiPrediction.url;
};

const baseURL = getStatisticsBaseURL();

// eslint-disable-next-line no-console

const statisticsApi = axios.create({
	baseURL,
	timeout: 30000, // 30 segundos de timeout
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
});

// Interceptor de request para debug
statisticsApi.interceptors.request.use(
	function (config) {
		// eslint-disable-next-line no-console
		return config;
	},
	function (error) {
		// eslint-disable-next-line no-console
		console.error('❌ Statistics API Request Error:', error);
		return Promise.reject(error);
	}
);

// Interceptor de resposta igual ao api padrão
statisticsApi.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		let errorData;
		let statusCode;
		let errorMessage;
		if (error.response) {
			errorData = error.response.data[0];
			statusCode = errorData?.statusCode;
			errorMessage = errorData?.message;
		} else {
			if (
				error.code === 'ERR_NETWORK' &&
				error.config.baseURL.includes('statistics')
			) {
				errorData = { ...error };
				statusCode = error.code;
				errorMessage = error.message;
			}
		}
		const errorAction = getErrorAction(statusCode, errorMessage);
		if (errorAction) {
			localStorage.clear();
			window.location.href = errorAction.redirectUrl;
			customToast(errorAction.toast);
		}
		return Promise.reject(error);
	}
);

export default statisticsApi;
